import { createApp } from 'vue';
import { BuildReleaseLabels } from 'www-shared';
import FormApp from './external/FormApp.vue';
import i18n from './external/plugins/i18n';
import AntiSpamUtil from './external/util/AntiSpamUtil';
import ErrorUtil from './external/util/ErrorUtil';
import LocalhostTestingUtil from './external/util/LocalhostTestingUtil';

const tic = Date.now();

LocalhostTestingUtil.isEnabled(); // Will log info if enabled

try {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).wwwHekateBuildReleaseLabels = BuildReleaseLabels.LABEL;
  // eslint-disable-next-line no-console
  console.log(`wwwHekateBuildReleaseLabels: ${BuildReleaseLabels.LABEL}`);
} catch (e) { /** ignore */ }

let isFormFoundGlobal = false;
const loadApp = () => {
  /**
 * Load the frontend app(s) (shown on www)
 * Supports deprecated legacy pages with one form `<div id="formfort-success-message" /> <div id="formfort" form-id="123" />`
 * and multiple forms `<div class="formfort-loading" form-id="123"/><div class="formfort-success-message" form-id="123" />`
 */
  Array.from(document.querySelectorAll('div.formfort-loading[form-id]')).forEach((formFortElement) => {
    window.ptcDebug = window.ptcDebug || {};
    window.ptcDebug.formfortLoading = window.ptcDebug.formfortLoading || [];

    if (formFortElement.getAttribute('formfort-handled')) {
      window.ptcDebug.formfortLoading.push({
        msg: 'Already Handled',
        formId: formFortElement.getAttribute('form-id') || '',
      });
      return;
    }
    formFortElement.setAttribute('formfort-handled', 'true');

    let successMessageHtml = '';
    const element = document.querySelector('div.formfort-success-message[form-id]') || document.getElementById('formfort-success-message');
    if (element) {
      successMessageHtml = (element.cloneNode(true) as HTMLElement).innerHTML;
      element.remove();
    }

    window.ptcDebug.formfortLoading.push({
      msg: 'Loading',
      formId: formFortElement.getAttribute('form-id') || '',
    });

    createApp(FormApp, {
      formId: formFortElement.getAttribute('form-id'),
      formVariant: formFortElement.getAttribute('form-variant') || '',
      redirectUrl: formFortElement.getAttribute('redirect-url') || '',
      gaCategory: formFortElement.getAttribute('ga-category') || '',
      gaAction: formFortElement.getAttribute('ga-action') || '',
      hiddenStaticField1: formFortElement.getAttribute('hidden-static-field-1') || '',
      hiddenStaticField2: formFortElement.getAttribute('hidden-static-field-2') || '',
      successMessageHtml,
      submitText: formFortElement.getAttribute('submit-text') || 'Submit',
    })
      .use(i18n)
      .mount(formFortElement);

    window.ptcDebug.formfortLoading.push({
      msg: `Loaded in ${Date.now() - tic}ms`,
      formId: formFortElement.getAttribute('form-id') || '',
    });
    isFormFoundGlobal = true;
  });
};
const timeouts = [10, 100, 500, 1000, 5000, 10000, 30000];

timeouts.forEach((timeout) => {
  setTimeout(() => {
    loadApp();
    if (!isFormFoundGlobal) {
      // eslint-disable-next-line no-console
      console.log(`Loading app after ${timeout}ms...`);
    }
  }, timeout);
});
loadApp(); // Load immediately as well

setTimeout(() => {
  if (isFormFoundGlobal) return;
  ErrorUtil.safePostMessageToSentry({
    tag: 'HekateLoadError',
    msg: 'No form found on page after 30 seconds.',
  });
}, 30001); // If no form is found after 30 seconds, throw an error

try {
  AntiSpamUtil.handleTabsThatHaveBeenOpenForTooLong();
} catch (e) {
  ErrorUtil.internalError({ msg: 'Could not init anti-spam', error: e });
}
